<template>
  <v-container fluid>
    <!-- Replace existing snackbar with new styled version -->
    <v-snackbar
      v-model="processSnackbar.show"
      :timeout="processSnackbar.timeout"
      :color="processSnackbar.color"
      top
      :style="{ left: '50%', transform: 'translateX(-50%)' }"
      class="notification-snackbar"
    >
      <v-alert
        :value="true"
        :color="processSnackbar.color"
        :icon="getSnackbarIcon"
        class="mb-0"
        dense
        outlined
        text
      >
        <div class="d-flex align-center">
          <v-progress-circular
            v-if="processSnackbar.loading"
            indeterminate
            size="20"
            width="2"
            :color="processSnackbar.color"
            class="mr-3"
          ></v-progress-circular>
          <span :class="`${processSnackbar.color}--text`">{{
            processSnackbar.text
          }}</span>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!processSnackbar.loading"
            icon
            x-small
            :color="processSnackbar.color"
            @click="processSnackbar.show = false"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-alert>
    </v-snackbar>

    <!-- Optional: Tooltip for guidance, shown on hover -->
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="primary"
              small
              v-bind="attrs"
              v-on="on"
              class="ml-2"
              style="cursor: pointer"
              >mdi-information-outline</v-icon
            >
          </template>
          <span>
            Use <strong>Add Case</strong> to create a new case file.<br />
            Access <strong>Archive</strong> to view closed or cancelled cases.
          </span>
        </v-tooltip>
      </v-col>
    </v-row>

    <!-- Add Case Dialog -->
    <v-dialog v-model="addDialog" max-width="600px" persistent>
      <!-- Add your existing case dialog content here -->
      <v-card tile>
        <v-card-title class="justify-center text-h5 grey lighten-2">
          <span class="text-h5">ADD NEW CASE</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-card width="100%">
                <v-card-title>Department</v-card-title>
                <v-col cols="12">
                  <v-select
                    v-model="newItem.refType"
                    :items="sortedRefType"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '400' }"
                    hint="Select Department"
                    persistent-hint
                    label="Department"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >Department
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="newItem.subRefType"
                    :items="filtersubRefType(newItem.refType)"
                    item-text="subCode"
                    item-value="id"
                    no-data-text="There is no file-Classification option for selected department above"
                    :menu-props="{ maxHeight: '400' }"
                    label="File-Classification"
                    hint="Select File-Classification"
                    persistent-hint
                  ></v-select>
                </v-col>
              </v-card>
              <v-col cols="12">
                <v-select
                  v-model="newItem.branch"
                  :items="sortedBranches"
                  item-text="name"
                  item-value="id"
                  :menu-props="{ maxHeight: '400' }"
                  hint="Set the casefile branch"
                  persistent-hint
                  label="Branch"
                >
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="newItem.insurer"
                  :items="sortedInsurer"
                  item-text="name"
                  item-value="id"
                  :menu-props="{ maxHeight: '400' }"
                  hint="Set the casefile insurer"
                  persistent-hint
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>Insurer
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="newItem.handler"
                  :items="filterHandler(newItem.insurer)"
                  item-text="name"
                  item-value="id"
                  no-data-text="There is no handler option for selected insurer above"
                  :menu-props="{ maxHeight: '400' }"
                  label="Claim Handler"
                  hint="Select Handler"
                  persistent-hint
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="newItem.claimNo"
                  item-text="Insurer's Reference"
                  label="Insurers Reference Number"
                  :rules="[(v) => !!v || 'Insurers reference is required']"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>Insurers
                    Reference
                  </template></v-text-field
                >
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <template>
                  <div>
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      max-width="290"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="ComputedDateOfAssignAdd"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="date = null"
                        >
                          <template #label>
                            <span class="red--text"><strong>* </strong></span
                            >Date Of Assignment
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="newItem.dateOfAssign"
                        @change="menu = false"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </template>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="newItem.vehicleNo"
                  label="Vehicle Number"
                  hint="Vehicle Number"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <template>
                  <div>
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      max-width="290"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="ComputedDateOfLossAdd"
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="date = null"
                        >
                          <template #label>
                            <span class="red--text"><strong>* </strong></span
                            >Date Of Loss
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="newItem.dateOfLoss"
                        @change="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </template>
              </v-col>
              <v-card width="100%">
                <v-card-title>Place Of Loss</v-card-title>
                <v-col cols="12">
                  <v-select
                    v-model="newItem.stateOfLoss"
                    :items="sortedState"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '400' }"
                    hint="Select State"
                    persistent-hint
                    label="State"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="newItem.placeOfLoss"
                    :items="filterRegions(newItem.stateOfLoss)"
                    item-text="name"
                    item-value="name"
                    no-data-text="There is no district option for selected state above"
                    :menu-props="{ maxHeight: '400' }"
                    label="Area Of Loss"
                    hint="Select District"
                    persistent-hint
                  ></v-select>
                </v-col>
              </v-card>

              <v-col cols="12">
                <v-text-field
                  v-model="newItem.insuredName"
                  label="Insured Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="newItem.insComment"
                  label="Insurers Comment"
                  :rules="[
                    (v) => !!v || 'Insurers comment is required',
                    (v) =>
                      v.length <= 2000 ||
                      'Comment must be 2000 characters or less',
                  ]"
                  counter
                  maxlength="2000"
                  auto-grow
                  rows="4"
                  row-height="20"
                  filled
                  background-color="grey lighten-4"
                  :hint="`${
                    newItem.insComment ? newItem.insComment.length : 0
                  }/2000 characters`"
                  persistent-hint
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span>
                    Insurers Comment
                  </template>
                </v-textarea>
              </v-col>

              <!-- <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="newItem.fileStatus"
                  :items="stages"
                  item-text="name"
                  item-value="stageCode"
                  :menu-props="{ maxHeight: '400' }"
                  label="FILE STATUS"
                  hint="Set File Status - Will be removed on Production version"
                  persistent-hint
                ></v-select>
              </v-col> -->

              <v-col cols="12" sm="6" md="6">
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  small
                  tile
                  @click="closeAddDialog"
                  class="mt-3 mr-2"
                >
                  Cancel
                </v-btn>
                <v-btn
                  :disabled="isAddFileButtonDisabled"
                  class="success mt-3"
                  small
                  tile
                  @click="addCasefile"
                  >Submit</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Filter Controls -->
    <v-card class="pa-4 mb-4 elevation-2" outlined>
      <div class="d-flex justify-end mb-2">
        <v-btn text small class="clear-btn-ux" @click="clearFilters">
          <v-icon left small color="grey">mdi-filter-remove</v-icon>
          <span class="clear-btn-label">Clear</span>
        </v-btn>
      </div>
      <v-row dense>
        <v-col cols="12" md="2">
          <v-autocomplete
            clearable
            v-model="filters.insurer"
            :items="insurersForFilter"
            item-text="name"
            item-value="id"
            label="Insurer"
            :menu-props="{ maxHeight: '400' }"
            persistent-hint
            @change="onFilterChange"
            prepend-icon="mdi-domain"
            dense
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-autocomplete
            clearable
            v-model="filters.branch"
            :items="branchesForFilter"
            item-text="name"
            item-value="id"
            label="Branch"
            :menu-props="{ maxHeight: '400' }"
            persistent-hint
            @change="onBranchChange"
            prepend-icon="mdi-office-building"
            dense
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-autocomplete
            clearable
            v-model="filters.refType"
            :items="departmentsForFilter"
            item-text="name"
            item-value="id"
            label="Department"
            :menu-props="{ maxHeight: '400' }"
            persistent-hint
            @change="onDeptChange"
            prepend-icon="mdi-account-group"
            dense
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-autocomplete
            clearable
            v-model="filters.subRefType"
            :items="filteredSubRefTypes"
            item-text="subCode"
            item-value="id"
            label="File Classification"
            :menu-props="{ maxHeight: '400' }"
            persistent-hint
            :hint="'Select Department first to enable File Classification.'"
            :disabled="!filters.refType"
            @change="onFilterChange"
            prepend-icon="mdi-file-document-outline"
            dense
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-autocomplete
            clearable
            v-model="filters.adjuster"
            :items="filteredAdjusters"
            item-text="username"
            item-value="id"
            label="Adjuster"
            :menu-props="{ maxHeight: '400' }"
            persistent-hint
            :hint="'Select Branch first to enable Adjuster.'"
            :disabled="!filters.branch"
            @change="onFilterChange"
            prepend-icon="mdi-account-tie"
            dense
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-autocomplete
            clearable
            v-model="filters.fileStatus"
            :items="stagesForFilter"
            item-text="name"
            item-value="stageCode"
            label="Status"
            :menu-props="{ maxHeight: '400' }"
            persistent-hint
            @change="onFilterChange"
            prepend-icon="mdi-checkbox-marked-circle-outline"
            dense
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            clearable
            v-model="filters.vehicleNo"
            label="Vehicle No."
            @change="onFilterChange"
            prepend-icon="mdi-car"
            dense
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            clearable
            v-model="filters.id"
            label="AA Ref."
            @change="onFilterChange"
            prepend-icon="mdi-numeric"
            dense
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-menu v-model="menuStart" :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filters.startDate"
                label="Start Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
              />
            </template>
            <v-date-picker
              v-model="filters.startDate"
              @change="
                menuStart = false;
                onFilterChange();
              "
            />
          </v-menu>
        </v-col>
        <v-col cols="12" md="2">
          <v-menu v-model="menuEnd" :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filters.endDate"
                label="End Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
              />
            </template>
            <v-date-picker
              v-model="filters.endDate"
              @change="
                menuEnd = false;
                onFilterChange();
              "
            />
          </v-menu>
        </v-col>
      </v-row>
    </v-card>

    <v-row>
      <v-col cols="12">
        <!-- Top Pagination Controls -->
        <div
          class="pagination-bar d-flex align-center justify-space-between mb-2 flex-wrap"
        >
          <!-- Add Case & Archive Buttons (inside top navigation bar, before pagination controls) -->
          <div class="add-archive-bar-v2-compact mr-2">
            <template v-if="!addCasefileDisabled">
              <v-btn
                color="primary"
                dark
                large
                class="add-case-btn-v2 mx-1"
                :disabled="addCasefileDisabled"
                @click="addDialog = true"
              >
                <v-icon left size="24">mdi-plus-circle</v-icon>
                Add Case
              </v-btn>
              <v-btn
                color="success"
                dark
                large
                class="archive-btn-v2 mx-1"
                to="/archive"
              >
                <v-icon left size="24">mdi-archive</v-icon>
                Archive
              </v-btn>
            </template>
            <template v-else>
              <v-btn
                color="success"
                dark
                large
                class="archive-btn-v2"
                style="width: 100%"
                to="/archive"
              >
                <v-icon left size="24">mdi-archive</v-icon>
                Archive
              </v-btn>
            </template>
          </div>
          <div class="pagination-controls d-flex align-center flex-wrap">
            <v-select
              :items="[30, 50, 100, 500]"
              v-model="pageSize"
              label="Rows"
              dense
              hide-details
              style="max-width: 90px"
              @change="onPageSizeChange"
              class="pagination-select"
            ></v-select>
            <v-btn
              icon
              :disabled="paginatedPage === 1"
              @click="goToFirstPage"
              class="pagination-btn"
            >
              <v-icon small>mdi-page-first</v-icon>
            </v-btn>
            <v-btn
              icon
              :disabled="paginatedPage === 1"
              @click="goToPrevPage"
              class="pagination-btn"
            >
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <!-- Fix: move :key to v-btn and span, not <template> -->
            <template v-for="btn in paginationButtons">
              <v-btn
                v-if="btn.type === 'page'"
                :key="'page-' + btn.page"
                small
                :color="btn.page === localPaginatedPage ? 'primary' : ''"
                @click="setPage(btn.page)"
                class="mx-1 pagination-btn"
              >
                {{ btn.page }}
              </v-btn>
              <span
                v-else-if="btn.type === 'ellipsis'"
                :key="'ellipsis-' + btn.key"
                class="mx-1 pagination-ellipsis"
                >...</span
              >
            </template>
            <v-btn
              icon
              :disabled="paginatedPage === totalPages"
              @click="goToNextPage"
              class="pagination-btn"
            >
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn
              icon
              :disabled="paginatedPage === totalPages"
              @click="goToLastPage"
              class="pagination-btn"
            >
              <v-icon small>mdi-page-last</v-icon>
            </v-btn>
            <v-text-field
              v-model.number="jumpToPage"
              label="Go to"
              type="number"
              dense
              hide-details
              style="max-width: 60px"
              min="1"
              :max="totalPages"
              @keyup.enter="jumpPage"
              class="ml-2 pagination-jump"
            ></v-text-field>
          </div>
          <span class="ml-2 pagination-total">
            {{ paginatedTotal }} total records
          </span>
        </div>
        <!-- Data Table -->
        <v-data-table
          dense
          :headers="headers"
          :items="paginatedCasefiles"
          :item-class="itemClass"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :loading="paginatedLoading"
          :search="search"
          :items-per-page="pageSize"
          class="elevation-1"
          mobile-breakpoint="1100"
          @click:row="viewItem"
          style="cursor: pointer"
          hide-default-footer
        >
          <template slot="item.numbering" slot-scope="props">
            {{ (paginatedPage - 1) * pageSize + props.index + 1 }}
          </template>

          <template v-slot:[`item.insurer`]="{ item }">
            <div v-for="ins in filterIns(item.insurer)" :key="ins.id">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="text-truncate"
                    style="max-width: 100px"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ ins.name }}
                  </div>
                </template>
                <span>{{ ins.name }}</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:[`item.vehicleNo`]="{ item }">
            <span v-if="item.vehicleNo">{{
              item.vehicleNo.toUpperCase()
            }}</span>
            <span v-else>TBA</span>
          </template>

          <template v-slot:[`item.id`]="{ item }">
            AA
            <span
              v-for="(dept, index) in filterDept(item.refType)"
              :key="index"
            >
              /{{ dept.name }}
              <span
                v-for="(subDept, index) in filterSubDept(item.subRefType)"
                :key="index"
              >
                /{{ subDept.subCode }}
              </span>
            </span>
            /{{ item.id }}/{{ yearOnly(item.dateOfAssign) }}
            <span
              v-for="branch in filterBranches(item.branch)"
              :key="branch.id"
            >
              /{{ branch.brCode }}
            </span>
          </template>

          <template v-slot:[`item.dateOfAssign`]="{ item }">
            {{ formatDate(item.dateOfAssign) }}
          </template>

          <template v-slot:[`item.days`]="{ item }">
            {{
              dateDiff(moment(item.dateOfAssign).format(), moment().format())
            }}
          </template>

          <template v-slot:[`item.adjuster`]="{ item }">
            <span v-if="item.adjuster">
              <div
                v-for="adjuster in filterUser(item.adjuster)"
                :key="adjuster.id"
              >
                {{ adjuster.username }}
              </div>
            </span>
            <span v-else>TBA</span>
          </template>

          <template v-slot:[`item.fileStatus`]="{ item }">
            <v-tooltip left transition="fab-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-if="item.flag === 1"
                  small
                  color="green lighten-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-shield-check
                </v-icon>
                <v-icon
                  v-if="item.flag === 2"
                  small
                  color="orange lighten-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-shield-half-full
                </v-icon>
                <v-icon
                  v-if="item.flag === 3"
                  small
                  color="red darken-5"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-shield-alert-outline
                </v-icon>
              </template>
              <span v-if="item.flag === 1">GENUINE</span>
              <span v-if="item.flag === 2">SUSPECTED FRAUD</span>
              <span v-if="item.flag === 3">FRAUD</span>
            </v-tooltip>

            <span
              v-for="allStatus in filterStages(item.fileStatus)"
              :key="allStatus.id"
            >
              <v-chip label outlined block x-small>
                {{ allStatus.name }}
              </v-chip>
            </span>
          </template>
        </v-data-table>
        <!-- Bottom Pagination Controls -->
        <div
          class="pagination-bar d-flex align-center justify-space-between mt-2 flex-wrap"
        >
          <div class="pagination-controls d-flex align-center flex-wrap">
            <v-select
              :items="[30, 50, 100, 500]"
              v-model="pageSize"
              label="Rows"
              dense
              hide-details
              style="max-width: 90px"
              @change="onPageSizeChange"
              class="pagination-select"
            ></v-select>
            <v-btn
              icon
              :disabled="paginatedPage === 1"
              @click="goToFirstPage"
              class="pagination-btn"
            >
              <v-icon small>mdi-page-first</v-icon>
            </v-btn>
            <v-btn
              icon
              :disabled="paginatedPage === 1"
              @click="goToPrevPage"
              class="pagination-btn"
            >
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <!-- Fix: move :key to v-btn and span, not <template> -->
            <template v-for="btn in paginationButtons">
              <v-btn
                v-if="btn.type === 'page'"
                :key="'page-' + btn.page"
                small
                :color="btn.page === localPaginatedPage ? 'primary' : ''"
                @click="setPage(btn.page)"
                class="mx-1 pagination-btn"
              >
                {{ btn.page }}
              </v-btn>
              <span
                v-else-if="btn.type === 'ellipsis'"
                :key="'ellipsis-' + btn.key"
                class="mx-1 pagination-ellipsis"
                >...</span
              >
            </template>
            <v-btn
              icon
              :disabled="paginatedPage === totalPages"
              @click="goToNextPage"
              class="pagination-btn"
            >
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn
              icon
              :disabled="paginatedPage === totalPages"
              @click="goToLastPage"
              class="pagination-btn"
            >
              <v-icon small>mdi-page-last</v-icon>
            </v-btn>
            <v-text-field
              v-model.number="jumpToPage"
              label="Go to"
              type="number"
              dense
              hide-details
              style="max-width: 60px"
              min="1"
              :max="totalPages"
              @keyup.enter="jumpPage"
              class="ml-2 pagination-jump"
            ></v-text-field>
          </div>
          <span class="ml-2 pagination-total">
            {{ paginatedTotal }} total records
          </span>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import DeptDataService from "@/services/DeptDataService";
import SubRefTypeDataService from "@/services/SubDeptDataService";
import InsDataService from "@/services/InsDataService";
import BranchDataService from "@/services/BranchDataService";
import StateDataService from "@/services/StateDataService";
import RegionDataService from "@/services/RegionDataService";
import MemberDataService from "@/services/MemberDataService";
import InsHandlerDataService from "@/services/HandlerDataService";
import StagesDataService from "@/services/StageDataService";
import TatChartDataService from "@/services/TatChartDataService";
import MailDataService from "@/services/MailDataService";
import CasefileDataService from "@/services/CasefileDataService";

export default {
  name: "CaseList",

  data: () => ({
    search: "",
    refType: [],
    subRefTypes: [],
    insurer: [],
    members: [],
    stages: [],
    tatCharts: [],
    addDialog: false,
    management: false,
    addcase: false,
    menu: false,
    menu1: false,
    newItem: {
      id: null,
      refType: null,
      subRefType: null,
      branch: null,
      insurer: null,
      handler: null,
      claimNo: "",
      dateOfAssign: "",
      vehicleNo: "",
      dateOfLoss: "",
      stateOfLoss: null,
      placeOfLoss: "",
      insuredName: "",
      insComment: "",
      createdBy: null,
      fileStatus: "",
      dateStartInv: "",
    },
    initialNewItem: {
      id: null,
      refType: null,
      subRefType: null,
      branch: null,
      insurer: null,
      handler: null,
      claimNo: "",
      dateOfAssign: "",
      vehicleNo: "",
      dateOfLoss: "",
      stateOfLoss: null,
      placeOfLoss: "",
      insuredName: "",
      insComment: "",
      createdBy: null,
      fileStatus: "",
      dateStartInv: "",
    },
    sortBy: ["days"], // Sort by DAYS column
    sortDesc: [true], // Descending order (highest first)
    // This is the original branches property
    branches: [],
    state: [],
    regions: [],
    handlers: [],

    headers: [
      {
        text: "NO.",
        align: "start",
        sortable: false,
        value: "numbering",
      },
      {
        text: "VEHICLE NO.",
        align: "center",
        value: "vehicleNo",
        sortable: false,
      },
      {
        text: "AA REF",
        align: "start",
        value: "id",
        sortable: false,
      },
      {
        text: "INSURER",
        align: "start",
        value: "insurer",
        sortable: false,
      },
      {
        text: "DOA",
        align: "start",
        sortable: false,
        value: "dateOfAssign",
      },
      {
        text: "DAYS",
        align: "start",
        sortable: false,
        value: "days",
      },
      {
        text: "ADJUSTER",
        align: "start",
        sortable: false,
        value: "adjuster",
      },
      {
        text: "STATUS",
        align: "center",
        value: "fileStatus",
        sortable: false,
      },
    ],
    showLoadingSnackbar: false, // Add this property
    isLoading: true,
    processSnackbar: {
      show: false,
      text: "",
      color: "info",
      timeout: 3000,
      loading: false,
    },
    searchLoading: false,
    advancedSearch: {
      keyword: "",
      dept: null,
      branch: null,
      status: null,
      insurer: null, // Add this line
    },
    // Remove the duplicate "branches" declaration
    departments: [], // Keep only this line
    filters: {
      insurer: "",
      branch: "",
      refType: "",
      subRefType: "",
      adjuster: "",
      fileStatus: "",
      vehicleNo: "",
      id: "",
      startDate: null,
      endDate: null,
    },
    menuStart: false,
    menuEnd: false,
    localPaginatedPage: 1,
    jumpToPage: null, // <-- Add this line
  }),

  computed: {
    // Use only correct getter names
    ...mapGetters([
      "getPaginatedPermittedActive",
      "getPaginatedTotalPermittedActive",
      "getPaginatedPermittedActiveLoading",
    ]),
    paginatedCasefiles() {
      return this.getPaginatedPermittedActive;
    },
    paginatedTotal() {
      return this.getPaginatedTotalPermittedActive;
    },
    paginatedLoading() {
      return this.getPaginatedPermittedActiveLoading;
    },
    paginatedPage: {
      get() {
        // Defensive: fallback to 1 if undefined
        const store = this.$store.state.casefiles;
        return (
          (store &&
            store.paginatedPermittedActive &&
            store.paginatedPermittedActive.page) ||
          1
        );
      },
      set(val) {
        this.setPage(val);
      },
    },
    pageSize: {
      get() {
        const store = this.$store.state.casefiles;
        return (
          (store &&
            store.paginatedPermittedActive &&
            store.paginatedPermittedActive.pageSize) ||
          30
        );
      },
      set(val) {
        // Optionally, update pageSize in store if needed
        this.onPageSizeChange(val);
      },
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.paginatedTotal / this.pageSize));
    },
    paginationButtons() {
      // Returns array of { type: 'page', page: n } or { type: 'ellipsis', key: '...' }
      const pages = [];
      const total = this.totalPages;
      const current = this.paginatedPage;
      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push({ type: "page", page: i });
        }
      } else {
        if (current <= 4) {
          for (let i = 1; i <= 5; i++) pages.push({ type: "page", page: i });
          pages.push({ type: "ellipsis", key: "e1" });
          pages.push({ type: "page", page: total });
        } else if (current >= total - 3) {
          pages.push({ type: "page", page: 1 });
          pages.push({ type: "ellipsis", key: "e2" });
          for (let i = total - 4; i <= total; i++)
            pages.push({ type: "page", page: i });
        } else {
          pages.push({ type: "page", page: 1 });
          pages.push({ type: "ellipsis", key: "e3" });
          for (let i = current - 1; i <= current + 1; i++)
            pages.push({ type: "page", page: i });
          pages.push({ type: "ellipsis", key: "e4" });
          pages.push({ type: "page", page: total });
        }
      }
      return pages;
    },
    addCasefileDisabled() {
      // Example logic: disable if not allowed to add
      return !this.addcase;
    },
    departmentsForFilter() {
      if (!this.refType || this.refType.length === 0) return [];
      const user = this.$store.state.auth.user;
      if (!user) return [];
      if (
        user.roles.some((role) => ["ADMIN", "MANAGER", "CLERK"].includes(role))
      ) {
        const sortedDepts = [...this.refType].sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        return sortedDepts;
      }
      const userDepts = Array.isArray(user.dept) ? user.dept : [user.dept];
      const filteredDepts = this.refType
        .filter((dept) => userDepts.some((userDept) => userDept === dept.id))
        .sort((a, b) => a.name.localeCompare(b.name));
      return filteredDepts;
    },
    branchesForFilter() {
      if (!this.branches || this.branches.length === 0) return [];
      const user = this.$store.state.auth.user;
      if (!user) return [];
      if (
        user.roles.some((role) => ["ADMIN", "MANAGER", "CLERK"].includes(role))
      ) {
        return [...this.branches]
          .map((b) => ({
            ...b,
            name: b.name ? b.name.trim().toUpperCase() : "",
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
      }
      const userBranches = Array.isArray(user.branches)
        ? user.branches
        : [user.branches];
      const filteredBranches = this.branches
        .filter((branch) =>
          userBranches.some((userBranch) => userBranch === branch.id)
        )
        .map((b) => ({
          ...b,
          name: b.name ? b.name.trim().toUpperCase() : "",
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
      return filteredBranches;
    },
    insurersForFilter() {
      if (!this.insurer || this.insurer.length === 0) return [];
      return [...this.insurer]
        .map((ins) => ({
          ...ins,
          name: ins.name ? ins.name.trim().toUpperCase() : "",
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    stagesForFilter() {
      if (!this.stages || this.stages.length === 0) return [];
      // Only show statuses except CANC and CLO
      const filteredStages = this.stages
        .filter(
          (stage) => stage.stageCode !== "CANC" && stage.stageCode !== "CLO"
        )
        .sort((a, b) => a.id - b.id);
      return [{ stageCode: "all", name: "All Statuses" }, ...filteredStages];
    },
    isAdvancedSearchValid() {
      return Boolean(
        this.advancedSearch.keyword ||
          this.advancedSearch.dept ||
          this.advancedSearch.branch ||
          this.advancedSearch.status ||
          this.advancedSearch.insurer
      );
    },
    sortedRefType() {
      return [...this.refType].sort((a, b) => a.name.localeCompare(b.name));
    },
    sortedBranches() {
      return [...this.branches].sort((a, b) => a.name.localeCompare(b.name));
    },
    sortedInsurer() {
      return [...this.insurer].sort((a, b) => a.name.localeCompare(b.name));
    },
    sortedState() {
      return [...this.state].sort((a, b) => a.name.localeCompare(b.name));
    },
    isAddFileButtonDisabled() {
      return !(
        this.newItem.refType &&
        this.newItem.insurer &&
        this.newItem.claimNo &&
        this.newItem.dateOfAssign &&
        this.newItem.dateOfLoss &&
        this.newItem.insComment
      );
    },
    getSnackbarIcon() {
      switch (this.processSnackbar.color) {
        case "success":
          return "mdi-check-circle";
        case "error":
          return "mdi-alert-circle";
        case "warning":
          return "mdi-alert";
        default:
          return "mdi-information";
      }
    },
    ComputedDateOfAssignAdd() {
      return this.formatDateMethod(this.newItem.dateOfAssign);
    },
    ComputedDateOfLossAdd() {
      return this.formatDateMethod(this.newItem.dateOfLoss);
    },
    filteredSubRefTypes() {
      if (!this.filters.refType) return [];
      return this.subRefTypes
        .filter(
          (sub) =>
            sub.deptId === this.filters.refType ||
            sub.deptId === Number(this.filters.refType) ||
            sub.deptId === String(this.filters.refType)
        )
        .sort((a, b) => a.subCode.localeCompare(b.subCode));
    },
    filteredAdjusters() {
      if (!this.filters.branch) return [];
      const branchObj = this.branches.find(
        (b) =>
          b.id === this.filters.branch ||
          b.id === Number(this.filters.branch) ||
          b.id === String(this.filters.branch)
      );
      if (!branchObj) return [];
      return this.members
        .filter((adj) => {
          // Must be active (boolean)
          if (adj.active !== true) return false;
          // Must have adjuster role
          if (
            !Array.isArray(adj.roles) ||
            !adj.roles.some((r) => r.roleCode === "adjuster")
          )
            return false;
          // Must be assigned to the branch
          if (Array.isArray(adj.branches)) {
            // branches as array of objects with name
            if (adj.branches.some((b) => b.name === branchObj.name))
              return true;
            // branches as array of IDs
            if (
              adj.branches.some(
                (b) =>
                  b === branchObj.id ||
                  b === Number(branchObj.id) ||
                  b === String(branchObj.id)
              )
            )
              return true;
          }
          return false;
        })
        .map((adj) => ({
          ...adj,
          username: adj.username ? adj.username.trim().toUpperCase() : "",
        }))
        .sort((a, b) => a.username.trim().localeCompare(b.username.trim()));
    },
  },
  methods: {
    moment(date) {
      return moment(date);
    },

    formatDate(value) {
      return moment(value).format("DD/MM/YYYY");
    },

    formatDateMethod(date) {
      if (!date) return null;
      return moment(date).format("DD/MM/YYYY");
    },

    yearOnly(value) {
      return moment(value).format("YY");
    },

    dateDiff(startDateString, endDateString) {
      let start = moment(startDateString);
      let end = moment(endDateString);
      let duration = moment.duration(end.diff(start));
      return Math.floor(duration.asDays());
    },

    filterDept(item) {
      return this.refType.filter((dept) => dept.id === item);
    },

    filterSubDept(item) {
      return this.subRefTypes.filter((subDept) => subDept.id === item);
    },

    filtersubRefType(item) {
      if (!item) return [];
      return [...this.subRefTypes]
        .filter((subRefType) => subRefType.deptId === item)
        .sort((a, b) => a.subCode.localeCompare(b.subCode));
    },

    filterHandler(item) {
      if (!item) return [];
      return [...this.handlers]
        .filter((handler) => handler.insId === item)
        .sort((a, b) => a.name.localeCompare(b.name));
    },

    filterBranches(item) {
      return this.branches.filter((branch) => branch.id === item);
    },

    filterBranchesEmail(item) {
      if (!item) return "TBA";
      const filteredbranch = this.branches.filter(
        (branch) => branch.id === item
      );

      return filteredbranch[0].name;
    },

    filterVehicleNo(item) {
      if (!item) return "TBA";
      return item.toLowerCase().replace(/\s/g, "");
    },

    filterIns(item) {
      return this.insurer.filter((ins) => ins.id === item);
    },

    filterUser(item) {
      return this.members.filter((member) => member.id === item);
    },

    filterStages(item) {
      return this.stages.filter((stage) => stage.stageCode === item);
    },

    filterRegions(item) {
      return this.regions.filter((region) => region.branchId === item);
    },

    viewItem(item) {
      this.$router.push({
        name: "vuexFile",
        params: { id: item.id },
      });
    },

    getTatValues(insurerId, subRefTypeId) {
      if (!insurerId || !subRefTypeId) return null;
      const filteredTat = this.tatCharts.find(
        (tat) => tat.insId === insurerId && tat.subDeptId === subRefTypeId
      );
      return filteredTat
        ? {
            tatAlert: parseInt(filteredTat.tatAlert),
            tatMax: parseInt(filteredTat.tatMax),
          }
        : null;
    },

    getStatusClass(days, tatAlert, tatMax) {
      const daysNum = Number(days);
      const alertNum = Number(tatAlert);
      const maxNum = Number(tatMax);

      if (daysNum >= maxNum) return "tat-overdue-force";
      if (daysNum >= alertNum) return "tat-alert-force";
      return "";
    },

    itemClass(item) {
      if (!item || !item.dateOfAssign) return "";
      const days = this.dateDiff(
        moment(item.dateOfAssign).format(),
        moment().format()
      );

      const tatValues = this.getTatValues(item.insurer, item.subRefType);
      if (!tatValues) return "";

      return this.getStatusClass(days, tatValues.tatAlert, tatValues.tatMax);
    },

    checkManagement() {
      const user = this.$store.state.auth.user;
      if (!user || !user.roles) {
        this.management = false;
        return;
      }
      if (
        user.roles.includes(`ADMIN`) ||
        user.roles.includes(`MANAGER`) ||
        user.roles.includes(`BRANCHMANAGER`) ||
        user.roles.includes(`BRANCHCLERK`)
      ) {
        this.management = true;
      } else {
        this.management = false;
      }
    },

    checkAddCase() {
      const user = this.$store.state.auth.user;
      if (!user || !user.roles) {
        this.addcase = false;
        return;
      }
      this.addcase = user.roles.some((role) =>
        ["ADMIN", "MANAGER", "CLERK", "BRANCHMANAGER", "BRANCHCLERK"].includes(
          role
        )
      );
    },

    closeAddDialog() {
      this.addDialog = false;
      this.$nextTick(() => {
        this.newItem = Object.assign({}, this.initialNewItem);
      });
    },

    addCasefile() {
      var data = {
        refType: this.newItem.refType,
        subRefType: this.newItem.subRefType,
        branch: this.newItem.branch,
        insurer: this.newItem.insurer,
        handler: this.newItem.handler,
        claimNo: this.newItem.claimNo,
        dateOfAssign: this.newItem.dateOfAssign,
        vehicleNo: this.filterVehicleNo(this.newItem.vehicleNo),
        dateOfLoss: this.newItem.dateOfLoss,
        stateOfLoss: this.newItem.stateOfLoss,
        placeOfLoss: this.newItem.placeOfLoss,
        insuredName: this.newItem.insuredName,
        insComment: this.newItem.insComment,
        createdBy: this.$store.state.auth.user.id,
        flag: 1,
        fileStatus: `NEW`,
        caseFrom: `ORGANIC`,
      };

      var dataEmail = {
        refType:
          this.refType.find((dept) => dept.id === this.newItem.refType)?.name ||
          "N/A",
        subRefType:
          this.subRefTypes.find((sub) => sub.id === this.newItem.subRefType)
            ?.subCodeDesc || "N/A",
        branch: this.filterBranchesEmail(this.newItem.branch),
        insurer:
          this.insurer.find((ins) => ins.id === this.newItem.insurer)?.name ||
          "N/A",
        handler: this.newItem.handler,
        claimNo: this.newItem.claimNo,
        dateOfAssign: this.newItem.dateOfAssign,
        vehicleNo: this.newItem.vehicleNo
          ? this.newItem.vehicleNo.toLowerCase().replace(/\s/g, "")
          : "TBA",
        dateOfLoss: this.newItem.dateOfLoss,
        stateOfLoss: this.newItem.stateOfLoss,
        placeOfLoss: this.newItem.placeOfLoss,
        insuredName: this.newItem.insuredName,
        insComment: this.newItem.insComment,
        createdBy: this.$store.state.auth.user.id,
        flag: 1,
        fileStatus: `NEW`,
        caseFrom: `ORGANIC`,
      };

      CasefileDataService.create(data)
        .then((response) => {
          this.closeAddDialog();
          this.$store.dispatch("setSnackbar", {
            showing: true,
            color: "success",
            text: response.data.message || "Success",
          });
        })
        .then(() => {
          MailDataService.mailData(dataEmail)
            .then((response) => {
              this.$store.dispatch("setSnackbar", {
                showing: true,
                color: "success",
                text: response.data.message || "Email sent",
              });
            })
            .catch((e) => {
              this.$store.dispatch("setSnackbar", {
                showing: true,
                color: "error",
                text: e.toString(),
              });
            });
        })
        .catch((e) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text: e.response?.data?.message || e.message,
          });
        });

      this.closeAddDialog();
    },

    showProcessUpdate(text, isLoading = true, color = "info") {
      this.processSnackbar = {
        show: true,
        text,
        color,
        timeout: isLoading ? -1 : 3000,
        loading: isLoading,
      };
    },

    async loadData() {
      this.showProcessUpdate("Loading data...");
      try {
        const [
          refType,
          subRefTypes,
          branches,
          state,
          regions,
          insurer,
          members,
          handlers,
          stages,
          tatCharts,
        ] = await Promise.all([
          DeptDataService.getAll(),
          SubRefTypeDataService.getAll(),
          BranchDataService.getAll(),
          StateDataService.getAll(),
          RegionDataService.getAll(),
          InsDataService.getAll(),
          MemberDataService.getAll(),
          InsHandlerDataService.getAll(),
          StagesDataService.getAll(),
          TatChartDataService.getAll(),
        ]);

        this.refType = refType.data;
        this.subRefTypes = subRefTypes.data;
        this.branches = branches.data;
        this.state = state.data;
        this.regions = regions.data;
        this.insurer = insurer.data;
        this.members = members.data;
        this.handlers = handlers.data;
        this.stages = stages.data;
        this.tatCharts = tatCharts.data;

        this.showProcessUpdate("Data loaded successfully", false, "success");
      } catch (error) {
        console.error("Error loading data:", error);
        this.showProcessUpdate("Error loading data", false, "error");
      }
    },

    openAdvancedSearch() {
      this.$router.push({ name: "advancedSearch" });
    },
    async performAdvancedSearch() {
      if (!this.isAdvancedSearchValid) return;

      this.searchLoading = true;
      try {
        // Create minimal search parameters object
        const searchParams = {};

        if (this.advancedSearch.keyword) {
          searchParams.keyword = this.advancedSearch.keyword;
        }
        if (this.advancedSearch.dept && this.advancedSearch.dept !== "all") {
          searchParams.dept = this.advancedSearch.dept;
        }
        if (
          this.advancedSearch.branch &&
          this.advancedSearch.branch !== "all"
        ) {
          searchParams.branch = this.advancedSearch.branch;
        }
        if (
          this.advancedSearch.status &&
          this.advancedSearch.status !== "all"
        ) {
          searchParams.status = this.advancedSearch.status;
        }
        if (this.advancedSearch.insurer) {
          searchParams.insurer = this.advancedSearch.insurer;
        }

        // Create a minimal search history entry
        const searchEntry = {
          timestamp: Date.now(),
          params: searchParams,
          text: this.createSearchText(searchParams),
        };

        // Try to store the search history
        try {
          let searchHistory = [];
          const stored = localStorage.getItem("searchHistory");
          if (stored) {
            searchHistory = JSON.parse(stored);
          }

          // Keep only the 5 most recent searches
          searchHistory = [searchEntry, ...searchHistory.slice(0, 4)];

          // Store with size check
          const historyString = JSON.stringify(searchHistory);
          if (historyString.length <= 4096) {
            localStorage.setItem("searchHistory", historyString);
          } else {
            // If too large, store fewer items
            localStorage.setItem(
              "searchHistory",
              JSON.stringify([searchEntry])
            );
          }
        } catch (e) {
          console.warn("Search history storage failed:", e);
        }

        // Navigate to search results
        await this.$router.push({
          name: "advancedSearch",
          query: searchParams,
        });
      } catch (error) {
        console.error("Search error:", error);
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: "Search failed: " + error.message,
          color: "error",
        });
      } finally {
        this.searchLoading = false;
      }
    },

    createSearchText(params) {
      const parts = [];
      if (params.keyword) parts.push(`"${params.keyword}"`);
      if (params.dept) {
        const dept = this.refType.find((d) => d.id === params.dept);
        if (dept) parts.push(dept.name);
      }
      if (params.branch) {
        const branch = this.branches.find((b) => b.id === params.branch);
        if (branch) parts.push(branch.name);
      }
      if (params.status) {
        const status = this.stages.find((s) => s.stageCode === params.status);
        if (status) parts.push(status.name);
      }
      if (params.insurer) {
        const ins = this.insurer.find((i) => i.id === params.insurer);
        if (ins) parts.push(ins.name);
      }
      return parts.join(", ") || "Advanced Search";
    },

    resetAdvancedSearch() {
      this.advancedSearch = {
        keyword: "",
        dept: null,
        branch: null,
        status: null,
        insurer: null, // Add this line
      };
    },

    // Add this method if you track recent searches
    addToRecentSearches(text, data) {
      try {
        // Get existing searches or initialize empty array
        let searches = [];
        const savedSearches = localStorage.getItem("recentSearches");
        if (savedSearches) {
          searches = JSON.parse(savedSearches);
        }

        // Add new search at the beginning
        searches.unshift({ text, data });

        // Keep only the latest 5 searches to save space
        searches = searches.slice(0, 5);

        // Convert to string and check size
        const storageStr = JSON.stringify(searches);
        if (storageStr.length > 4096) {
          // Limit to ~4KB
          // If too large, keep fewer items
          searches = searches.slice(0, 3);
        }

        localStorage.setItem("recentSearches", JSON.stringify(searches));
        this.recentSearches = searches;
      } catch (e) {
        console.warn("Unable to save to recent searches:", e);
        // Clear existing searches if storage is full
        try {
          localStorage.removeItem("recentSearches");
          this.recentSearches = [];
        } catch (clearError) {
          console.error("Error clearing searches:", clearError);
        }
      }
    },

    // If you need to modify your existing retrieveData method to get additional data
    async loadFilterData() {
      try {
        // If not already loaded in loadData()
        if (!this.stages || this.stages.length === 0) {
          const stagesResponse = await StagesDataService.getAll();
          this.stages = stagesResponse.data;
        }

        if (!this.refType || this.refType.length === 0) {
          const deptResponse = await DeptDataService.getAll();
          this.refType = deptResponse.data;
        }

        if (!this.branches || this.branches.length === 0) {
          // Fix: Update branch data to this.branches (maintaining consistency)
          const branchResponse = await BranchDataService.getAll();
          this.branches = branchResponse.data;
        }
      } catch (error) {
        console.error("Error loading filter data:", error);
      }
    },
    async fetchPaginated() {
      const filters = {};
      Object.keys(this.filters).forEach((key) => {
        // Special handling for fileStatus "all"
        if (key === "fileStatus" && this.filters.fileStatus === "all") {
          // Do not include fileStatus filter
          return;
        }
        if (
          this.filters[key] !== null &&
          this.filters[key] !== "" &&
          typeof this.filters[key] !== "undefined"
        ) {
          filters[key] = this.filters[key];
        }
      });
      // Ensure adjuster filter is sent as id, not object
      if (
        filters.adjuster &&
        typeof filters.adjuster === "object" &&
        filters.adjuster.id
      ) {
        filters.adjuster = filters.adjuster.id;
      }
      // Ensure id filter is sent as a number if not empty
      if (filters.id) {
        filters.id = Number(filters.id);
      }
      // Only fetch permitted active casefiles
      await this.$store.dispatch("casefiles/fetchPaginatedPermittedActive", {
        page: this.paginatedPage,
        pageSize: this.pageSize,
        ...filters, // <-- Spread filters at top level
      });
    },
    onPageChange(page) {
      this.$store.dispatch("casefiles/fetchPaginatedPermittedActive", {
        page,
        pageSize: this.pageSize,
        ...this.filters, // <-- Spread filters at top level
      });
    },
    onPageSizeChange() {
      this.$store.dispatch("casefiles/fetchPaginatedPermittedActive", {
        page: 1,
        pageSize: this.pageSize,
        ...this.filters, // <-- Spread filters at top level
      });
      this.paginatedPage = 1;
    },
    onFilterChange() {
      // If "All Statuses" selected, clear fileStatus filter
      if (this.filters.fileStatus === "all") {
        this.filters.fileStatus = "";
      }
      this.paginatedPage = 1;
      this.fetchPaginated();
    },
    onBranchChange() {
      this.filters.adjuster = "";
      this.onFilterChange();
    },
    onDeptChange() {
      this.filters.subRefType = "";
      this.onFilterChange();
    },
    // Pagination navigation methods (added)
    goToFirstPage() {
      if (this.paginatedPage > 1) {
        this.onPageChange(1);
      }
    },
    goToPrevPage() {
      if (this.paginatedPage > 1) {
        this.onPageChange(this.paginatedPage - 1);
      }
    },
    goToNextPage() {
      if (this.paginatedPage < this.totalPages) {
        this.onPageChange(this.paginatedPage + 1);
      }
    },
    goToLastPage() {
      if (this.paginatedPage < this.totalPages) {
        this.onPageChange(this.totalPages);
      }
    },
    async clearFilters() {
      // Show loading snackbar
      this.showProcessUpdate("Reloading data...", true, "info");
      this.filters = {
        insurer: "",
        branch: "",
        refType: "",
        subRefType: "",
        adjuster: "",
        fileStatus: "",
        vehicleNo: "",
        id: "",
        startDate: null,
        endDate: null,
      };
      this.paginatedPage = 1;
      await this.fetchPaginated();
      // Hide loading snackbar after fetch
      this.showProcessUpdate("Data reloaded", false, "success");
    },
    // If you have a search text clear/enter handler, add similar logic:
    async onSearchClearOrEnter() {
      // Show loading snackbar
      this.showProcessUpdate("Reloading data...", true, "info");
      this.search = "";
      this.paginatedPage = 1;
      await this.fetchPaginated();
      this.showProcessUpdate("Data reloaded", false, "success");
    },
    setPage(page) {
      if (page !== this.localPaginatedPage) {
        this.localPaginatedPage = page;
      }
      // Always trigger fetch
      this.onPageChange(page);
    },
    jumpPage() {
      if (
        this.jumpToPage &&
        this.jumpToPage >= 1 &&
        this.jumpToPage <= this.totalPages
      ) {
        this.setPage(this.jumpToPage);
      }
    },
  },
  async mounted() {
    // Replace reloadActiveFiles(1) with fetchPaginated()
    await this.loadData();
    this.checkManagement();
    this.checkAddCase();
    await this.loadFilterData();
    // Always clear paginated casefiles before fetching with user context
    await this.$store.dispatch("casefiles/clearPaginatedCasefiles");
    this.fetchPaginated();
    this.localPaginatedPage = this.getPaginatedPage;
  },
  watch: {
    $route(to) {
      if (to.path === "/home") {
        // Always clear paginated casefiles before fetching with user context
        this.$store.dispatch("casefiles/clearPaginatedCasefiles").then(() => {
          this.fetchPaginated();
          this.paginatedPage = 1;
        });
      }
    },
    // Watch for user changes to update permission logic
    "$store.state.auth.user": {
      handler() {
        this.checkAddCase();
        this.checkManagement();
      },
      immediate: true,
      deep: true,
    },
    getPaginatedPage(val) {
      // Sync local page with store page
      this.localPaginatedPage = val;
    },
    localPaginatedPage(val) {
      // When local changes, update store if needed
      if (val !== this.getPaginatedPage) {
        this.onPageChange(val);
      }
    },
  },
  // Add this navigation guard to ensure correct data on navigation
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // Always clear and fetch with user context when entering Home
      vm.$store.dispatch("casefiles/clearPaginatedCasefiles").then(() => {
        vm.fetchPaginated();
        vm.paginatedPage = 1;
      });
    });
  },
};
</script>

<style>
.tat-alert-force {
  background-color: rgb(255, 241, 230) !important;
  border-left: 3px solid orange !important;
}

.tat-overdue-force {
  background-color: rgb(248, 204, 204) !important;
  border-left: 3px solid red !important;
}

.v-data-table >>> tbody tr.tat-alert-force:hover {
  background-color: rgb(255, 231, 220) !important;
}

.v-data-table >>> tbody tr.tat-overdue-force:hover {
  background-color: rgb(238, 194, 194) !important;
}

.v-snackbar {
  pointer-events: none;
}

.v-snackbar__wrapper {
  pointer-events: auto;
  cursor: pointer;
}

/* Add these new styles */
.quick-find-section {
  transition: all 0.3s ease;
}

.quick-find-input {
  transition: width 0.3s ease;
}

/* Mobile responsiveness */
@media (max-width: 600px) {
  .quick-find-section {
    width: 100%;
    margin-top: 8px;
  }

  .v-toolbar__content {
    flex-wrap: wrap;
  }

  .quick-find-input {
    max-width: none !important;
  }
}

/* Update the styles for the search section */
.search-section {
  width: 100%;
  transition: all 0.3s ease;
}

/* Keep the mobile responsiveness but for the new search layout */
@media (max-width: 768px) {
  .search-section {
    margin-bottom: 8px;
  }

  .v-toolbar__content {
    flex-wrap: wrap;
    height: auto !important;
    padding-bottom: 16px;
  }

  .v-btn {
    margin: 4px;
  }
}

/* Add these new styles for the enhanced layout */
.action-buttons-card {
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.search-card {
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.search-card-title {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background-color: rgba(0, 0, 0, 0.01);
}

.action-btn {
  min-width: 130px;
  height: 36px;
  text-transform: none;
  letter-spacing: 0.5px;
  font-weight: 500;
}

/* Pagination bar mobile compatibility */
.pagination-bar {
  flex-wrap: wrap;
  gap: 8px;
}
.pagination-controls {
  flex-wrap: wrap;
  gap: 4px;
}
.pagination-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 4px;
}
.pagination-select {
  min-width: 70px;
  max-width: 90px;
}
.pagination-jump {
  min-width: 50px;
  max-width: 60px;
}
.pagination-total {
  font-size: 15px;
  white-space: nowrap;
}
.pagination-ellipsis {
  font-size: 18px;
  color: #888;
}

/* Responsive styles for pagination bar */
@media (max-width: 600px) {
  .pagination-bar {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 4px;
  }
  .pagination-controls {
    flex-wrap: wrap;
    gap: 2px;
    margin-bottom: 4px;
  }
  .pagination-btn {
    min-width: 28px;
    height: 28px;
    font-size: 13px;
    padding: 0 2px;
  }
  .pagination-select {
    min-width: 60px;
    max-width: 70px;
    font-size: 13px;
  }
  .pagination-jump {
    min-width: 40px;
    max-width: 50px;
    font-size: 13px;
  }
  .pagination-total {
    font-size: 13px;
    margin-left: 0 !important;
  }
  .pagination-ellipsis {
    font-size: 16px;
  }
}

/* Version 2 Add Case & Archive Bar Styles */
.add-archive-bar-v2 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 24px;
  margin-bottom: 8px;
}
.add-case-btn-v2,
.archive-btn-v2 {
  min-width: 180px;
  height: 56px;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 28px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: box-shadow 0.2s;
}
.add-case-btn-v2:hover,
.archive-btn-v2:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}
.add-archive-desc-v2 {
  margin-top: 8px;
  font-size: 15px;
  color: #666;
}
@media (max-width: 600px) {
  .add-archive-bar-v2 {
    flex-direction: column;
    gap: 12px;
  }
  .add-case-btn-v2,
  .archive-btn-v2 {
    width: 100%;
    min-width: 0;
    font-size: 17px;
    height: 44px;
    border-radius: 22px;
  }
  .add-archive-desc-v2 {
    font-size: 13px;
  }
}

/* Compact horizontal bar for Add Case & Archive Buttons */
.add-archive-bar-v2-compact {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}
.add-case-btn-v2,
.archive-btn-v2 {
  min-width: 140px;
  height: 44px;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 22px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: box-shadow 0.2s;
}
.add-case-btn-v2:hover,
.archive-btn-v2:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}
@media (max-width: 600px) {
  .add-archive-bar-v2-compact {
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }
  .add-case-btn-v2,
  .archive-btn-v2 {
    width: 100%;
    min-width: 0;
    font-size: 15px;
    height: 38px;
    border-radius: 19px;
  }
}
.clear-btn-ux {
  background-color: #f5f5f5 !important;
  color: #757575 !important;
  font-style: italic;
  font-size: 13px;
  min-width: 70px;
  box-shadow: none !important;
  border-radius: 16px;
  transition: background 0.2s;
}
.clear-btn-ux:hover {
  background-color: #eeeeee !important;
}
.clear-btn-label {
  font-style: italic;
  color: #757575;
}
</style>
